import React, { useEffect, useState } from "react";
import moment from "moment";
import {
  abhaCartDownloadServices,
  CreateAbhaUserServices,
  UpdateAbhaUserServices
} from "../../services";
import { useSelector } from "react-redux";

const AbhaCard = ({ setIsVerifiedMobile }) => {
  const [abhacarddata, setAbhacarddata] = useState("");
  const [downlaoding, setDownloading] = useState(false);

  let userInfo = useSelector((state) => state.user.patientDetails);
  const [showFull, setShowFull] = useState(false);
  // const [updateuser, setUpdateUser] = useState(null);

  const existingAbha = JSON.parse(localStorage.getItem("existingAbha"));

  // console.log("existingAbha", existingAbha, typeof existingAbha);
  if (!existingAbha) {
    // console.log("********************************");
    const userData = JSON.parse(localStorage.getItem("userData"));
    if (userData?.accounts?.length > 0) {
      userInfo = userData?.accounts[0];
    } else if (userData?.users?.length > 0) {
      userInfo = userData?.users;
    } else {
      userInfo = userData;
    }
  }

  const downloadabha = async () => {
    setDownloading(true);
    try {
      const body = {
        xToken:
          localStorage.getItem("abhaxtoken") ||
          localStorage.getItem("downloadToken")
      };
      const response = await abhaCartDownloadServices({ body });
      console.log("ressponse", response, "++++");
      setAbhacarddata(response.result);
      // console.log("object", response);

      if (response.status) {
        const patientData = JSON.parse(localStorage.getItem("selectedIndex"));
        const aadharUser = JSON.parse(
          localStorage.getItem("aadharVerificationDetails")
        );
        const mobilenumber = localStorage.getItem("newmobilenumber");
        // console.log("patientData", patientData);
        // console.log("userInfo id", patientData?.pId);
        let dobValue =
          userInfo?.dob || aadharUser?.abhaDOB || aadharUser?.dob || null;

        let dob = dobValue ? new Date(dobValue) : null;

        console.log("dob", dob, "dob");

        let formattedDob = null;
        if (dob && !isNaN(dob)) {
          const yyyy = dob.getFullYear();
          const mm = String(dob.getMonth() + 1).padStart(2, "0");
          const dd = String(dob.getDate()).padStart(2, "0");
          formattedDob = `${yyyy}-${mm}-${dd}`;
        } else {
          formattedDob = moment(aadharUser.dob, "DD-MM-YYYY").format("YYYY-MM-DD") || null;
        }

        console.log("formattedDob", formattedDob, "formattedDob");

        const body = {
          patientId: patientData?._id,
          abhaAddress:
            userInfo?.abhaAddress ||
            userInfo?.preferredAbhaAddress ||
            aadharUser?.abhaAddress,
          healthIdNumber:
            userInfo?.abhaNumber ||
            userInfo?.ABHANumber ||
            userInfo?.healthIdNumber ||
            aadharUser?.abhaNumber,
          abhaDOB:
            formattedDob ||
            userInfo?.abhaDOB ||
            userInfo?.dob ||
            aadharUser?.abhaDOB ||
            aadharUser?.dob,
          abhaGender: userInfo?.gender || aadharUser?.gender,
          abhaName: [
            userInfo?.firstName,
            userInfo?.middleName,
            userInfo?.lastName
          ]
            .filter(Boolean)
            .join(" "),

          abhaCard: response?.result,
          fname: userInfo?.firstName || userInfo?.fullName,
          mname: userInfo?.middleName || "",
          lname: userInfo?.lastName,
          dob:
            formattedDob ||
            userInfo?.dob ||
            aadharUser?.abhaDOB ||
            aadharUser?.dob,
          gender: userInfo?.gender || aadharUser?.gender,
          fullname: [
            userInfo?.firstName,
            userInfo?.middleName,
            userInfo?.lastName
          ]
            .filter(Boolean)
            .join(" "),
          abhaNumber: userInfo?.abhaNumber || userInfo?.ABHANumber,
          abhaAddress: userInfo?.abhaAddress || userInfo?.preferredAbhaAddress,
          mobile: userInfo?.mobile || aadharUser?.mobile || mobilenumber
        };
        let responsed;
        if (patientData && patientData?._id) {
          responsed = await UpdateAbhaUserServices({ body });
        } else {
          responsed = await CreateAbhaUserServices({ body });
        }
        if (responsed.status) {
          localStorage.clear();
          console.log("ABHA user updated successfully");
        }
      }
    } catch (error) {
      console.error("Error while getting token:", error);
    } finally {
      setDownloading(false);
    }
  };
  const aabhacrt = "data:image/png;base64," + abhacarddata;

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = aabhacrt;
    link.download = "abha-card.png";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    // setIsVerifiedMobile(true);
    window.location.reload();
  };

  useEffect(() => {
    downloadabha();
  }, []);
  return (
    <>
      <section className="container">
        <div className="abha-create-steps">
          <div className="row">
            <div className="col-md-6">
              <div className="create-abha">
                <h2>Create ABHA Number in 3 Steps</h2>
                <p>
                  Create ABHA and store all your medical records in one place.
                  Take part in the{" "}
                  <span className="highlight">
                    Ayushman Bharat Digital Mission (ABDM)
                  </span>{" "}
                  and get started on your digital health journey.
                </p>

                <div className="vertical-steps">
                  <div className="step-item">
                    <div className="step-marker">1</div>
                    <div className="step-content">
                      <h4>Verify Aadhaar Details</h4>
                      <p>
                        Enter your Aadhaar number and verify with OTP received
                        on Aadhaar linked mobile number.
                      </p>
                    </div>
                  </div>

                  <div className="step-line" />

                  <div className="step-item">
                    <div className="step-marker">2</div>
                    <div className="step-content">
                      <h4>Link Mobile Number</h4>
                      <p>
                        Enter your mobile number and verify with OTP to link
                        with ABHA .
                      </p>
                    </div>
                  </div>

                  <div className="step-line" />

                  <div className="step-item">
                    <div className="step-marker">3</div>
                    <div className="step-content">
                      <h4>Create ABHA</h4>
                      <p>Create your ABHA Number with a unique ABHA .</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-card content">
                <h3>ABHA created successfully!</h3>
                <form className="pt-3">
                  <div className="col-ms-12 col-lg-12 col-xl-12 col-sm-12 col-xs-12">
                    <div className="p-3 text-center">
                      <img
                        src={aabhacrt}
                        className="abha-card-download"
                        alt="ABHA Card"
                        onClick={() => setShowFull(true)}
                      />
                    </div>
                  </div>
                  <button className="continue-btn" onClick={handleDownload}>
                    DOWNLOAD YOUR ABHA CARD NOW
                  </button>
                </form>

                {showFull && (
                  <div className="image-modal">
                    <span
                      className="close-btn2"
                      onClick={() => setShowFull(false)}
                    >
                      &times;
                    </span>
                    <img
                      src={aabhacrt}
                      className="modal-content"
                      alt="ABHA Card Full"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AbhaCard;
